// extracted by mini-css-extract-plugin
module.exports = {"preview":"preview_preview__1aPWo","app":"preview_app__3-Hbv","border":"preview_border__3l7vl","initials":"preview_initials__15y8o"};